var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("Справочники")]),_c('classifiers-table',{attrs:{"classifiers":_vm.classifiers}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }